import React from 'react';
import * as Yup from 'yup';
import MasterManager from '../../components/expense/MasterManager';

const schema = Yup.object().shape({
  code: Yup.string().trim().required('Code is required').matches(/^[A-Za-z]{3}$/, 'Code must be a 3-letter ISO code'),
  name: Yup.string().trim().required('Name is required').max(100),
  symbol: Yup.string().trim().max(10),
  minorUnits: Yup.number().typeError('Minor units must be a number').integer('Must be a whole number').min(0).max(4).required('Minor units is required'),
});

// Owner: HR admin. No exchange rates / conversion.
const CurrencyMaster = ({ canEdit }) => (
  <MasterManager
    resource="currencies"
    title="Currency"
    canEdit={canEdit}
    searchPlaceholder="Search code / name"
    columns={[
      { key: 'code', label: 'Code' },
      { key: 'name', label: 'Name' },
      { key: 'symbol', label: 'Symbol' },
      { key: 'minorUnits', label: 'Minor Units' },
    ]}
    fields={[
      { name: 'code', label: 'ISO Code', required: true, xs: 6, disabledOnEdit: true, inputProps: { maxLength: 3 }, helperText: 'Cannot be changed later' },
      { name: 'symbol', label: 'Symbol', xs: 6 },
      { name: 'name', label: 'Name', required: true },
      { name: 'minorUnits', label: 'Minor Units (decimal places)', type: 'number', required: true, inputProps: { min: 0, max: 4, step: 1 } },
    ]}
    validationSchema={schema}
    emptyValues={{ code: '', name: '', symbol: '', minorUnits: 2 }}
    toForm={(r) => ({ code: r.code || '', name: r.name || '', symbol: r.symbol || '', minorUnits: r.minorUnits ?? 2 })}
    toPayload={(v) => ({ code: v.code, name: v.name, symbol: v.symbol, minorUnits: Number(v.minorUnits) })}
  />
);

export default CurrencyMaster;
